(function (Drupal, once, drupalSettings) {
  'use strict';

  Drupal.behaviors.promotionExpiryReload = {
    attach: function (context) {
      once('promotion-expiry-reload', 'body', context).forEach(function () {
        var settings = drupalSettings.laysNlngPromotionExpiryReload || {};
        var endTimestamp = parseInt(settings.endTimestamp, 10);
        var webformId = settings.webformId || 'default';

        if (!endTimestamp || Number.isNaN(endTimestamp)) {
          return;
        }

        var nowSeconds = Math.floor(Date.now() / 1000);
        if (nowSeconds > endTimestamp) {
          return;
        }

        var storageKey = 'promotion_expiry_reloaded_' + webformId + '_' + endTimestamp;
        if (sessionStorage.getItem(storageKey) === '1') {
          return;
        }

        var msUntilReload = Math.max(0, ((endTimestamp + 1) * 1000) - Date.now());
        window.setTimeout(function () {
          if (sessionStorage.getItem(storageKey) === '1') {
            return;
          }

          sessionStorage.setItem(storageKey, '1');
          window.location.reload();
        }, msUntilReload);
      });
    }
  };
})(Drupal, once, drupalSettings);
